// middleware/require-auth.js
import { isJwtValid } from '~/utils/jwt';

function parseCookieString(str) {
    return (str || '').split(';').reduce((acc, pair) => {
        const i = pair.indexOf('=');
        if (i === -1) return acc;
        const k = decodeURIComponent(pair.slice(0, i).trim());
        const v = decodeURIComponent(pair.slice(i + 1).trim());
        acc[k] = v;
        return acc;
    }, {});
}

function readCookie(ctx, name) {
    if (process.server && ctx.req?.headers?.cookie) {
        return parseCookieString(ctx.req.headers.cookie)[name] || null;
    }
    if (process.client && typeof document !== 'undefined') {
        return parseCookieString(document.cookie || '')[name] || null;
    }
    return null;
}

// Подтягиваем globalSettings, если ещё не загружены
async function ensureGlobalSettings(store) {
    let gs = store.getters['global/globalSettings'];
    if (gs && Object.keys(gs).length) return gs;

    if (store._actions && store._actions['global/fetchGlobalSettings']) {
        try {
            await store.dispatch('global/fetchGlobalSettings');
            gs = store.getters['global/globalSettings'];
        } catch (_) {
            /* игнорируем, ниже будет безопасная проверка */
        }
    }
    return gs || null;
}

export default async function requireAuth(ctx) {
    const { store, redirect } = ctx;

    const gs = await ensureGlobalSettings(store);
    const isUserCabinet = !!(gs && gs?.additional_settings && gs?.additional_settings?.is_user_cabinet);
    if (!isUserCabinet) {
        return redirect('/?login=true');
    }

    // 2) Авторизация по access token в cookie
    const token = readCookie(ctx, 'token'); // твои куки: token / refresh_token
    const loggedIn = !!token && isJwtValid(token);
    if (!loggedIn) {
        return redirect('/?login=true');
    }
}
